import { render, staticRenderFns } from "./MsgRightImg.vue?vue&type=template&id=6e7d3080&scoped=true&"
import script from "./MsgRightImg.vue?vue&type=script&lang=js&"
export * from "./MsgRightImg.vue?vue&type=script&lang=js&"
import style0 from "./MsgRightImg.vue?vue&type=style&index=0&id=6e7d3080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7d3080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7d3080')) {
      api.createRecord('6e7d3080', component.options)
    } else {
      api.reload('6e7d3080', component.options)
    }
    module.hot.accept("./MsgRightImg.vue?vue&type=template&id=6e7d3080&scoped=true&", function () {
      api.rerender('6e7d3080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/MsgRightImg.vue"
export default component.exports